export const DATE_FORMAT_CAMERAS = 'DD.MM.YYYY HH:mm'